var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.1665H5.83329C5.39127 4.1665 4.96734 4.3421 4.65478 4.65466C4.34222 4.96722 4.16663 5.39114 4.16663 5.83317V15.8332C4.16663 16.2752 4.34222 16.6991 4.65478 17.0117C4.96734 17.3242 5.39127 17.4998 5.83329 17.4998H14.1666C14.6087 17.4998 15.0326 17.3242 15.3451 17.0117C15.6577 16.6991 15.8333 16.2752 15.8333 15.8332V5.83317C15.8333 5.39114 15.6577 4.96722 15.3451 4.65466C15.0326 4.3421 14.6087 4.1665 14.1666 4.1665H12.5",
    stroke: "#595959",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.5H9.16667C8.24619 2.5 7.5 3.24619 7.5 4.16667C7.5 5.08714 8.24619 5.83333 9.16667 5.83333H10.8333C11.7538 5.83333 12.5 5.08714 12.5 4.16667C12.5 3.24619 11.7538 2.5 10.8333 2.5Z",
    stroke: "#595959",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTx);
export default __webpack_public_path__ + "static/media/hashTx.7816da5c3b8274a98bce6d22edac0cd7.svg";
export { ForwardRef as ReactComponent };